<template>
  <div id="app" style="overflow-y: hidden;">
    <el-header v-if="showHeader" class="app-header">
      <div class="header-content">
        <div class="logo" @click="$router.push('/')">
          <img src="@/assets/logo.png" alt="Logo" class="logo-image">
          <span class="logo-text">UTS数据科技</span>
        </div>
        <el-menu :default-active="$route.path" class="nav-menu" mode="horizontal" router background-color="#545c64"
          text-color="#fff" active-text-color="#ffd04b" @select="handleMenuSelect">
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="tech-docs">技术文档</el-menu-item>
          <el-menu-item index="/buy">购买授权</el-menu-item>
          <el-menu-item v-if="isLoggedIn" index="/user">用户中心</el-menu-item>
          <!--<el-menu-item index="/aigc">AIGC智能内容服务</el-menu-item>-->
        </el-menu>
        <div class="user-actions">
          <!-- 未登录时显示登录按钮 -->
          <div v-if="!isLoggedIn" class="quick-actions">
            <el-button-group class="action-group">
              <el-button type="warning" @click="handleLoginClick" size="medium">
                <i class="el-icon-user-solid"></i> 登录
              </el-button>
              <el-button type="warning" @click="handleRegisterClick" size="medium">
                <i class="el-icon-user"></i> 注册
              </el-button>
            </el-button-group>

          </div>
          <!-- 已登录时显示用户信息 -->
          <div v-else>
            <el-dropdown @command="handleUserCommand" class="user-dropdown">
              <span class="user-info">
                <el-avatar :size="32" :src="userAvatar" class="user-avatar">
                  {{ userName.charAt(0).toUpperCase() }}
                </el-avatar>
                <span class="user-name">{{ userName }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="user-dropdown-menu">
                <el-dropdown-item command="profile" class="dropdown-item">
                  <i class="el-icon-user"></i>
                  用户中心
                </el-dropdown-item>
                <el-dropdown-item command="logout" class="dropdown-item logout-item">
                  <i class="el-icon-switch-button"></i>
                  退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- 授权按钮：开通会员/授权管理 -->
          <el-button v-if="showLicenseButton && !licenseStatus.loading"
            :type="showLicenseButton === 'manage' ? 'success' : 'primary'" @click="handleLicenseClick"
            class="license-btn" :loading="licenseStatus.loading" size="medium">
            <i v-if="showLicenseButton === 'manage'" class="el-icon-suitcase"></i>
            <i v-else class="el-icon-shopping-cart-2"></i>
            {{ licenseButtonText }}
            <!-- 授权状态提示 -->
            <el-tooltip
              v-if="showLicenseButton === 'manage' && licenseStatus.licenseInfo && licenseStatus.licenseInfo.daysRemaining > 0"
              :content="`${licenseStatus.licenseInfo.planName} | 剩余${licenseStatus.licenseInfo.daysRemaining}天`"
              placement="bottom">
              <i class="el-icon-info" style="margin-left: 5px;"></i>
            </el-tooltip>
          </el-button>
        </div>
      </div>
    </el-header>
    <el-main class="app-main">
      <!-- 技术文档：使用 v-show 控制显示，内嵌 iframe -->
      <div v-show="$route.path === '/tech-docs'" class="tech-docs-container">
        <iframe src="https://web.zealink.com/note/utsHelp.html?pageType=99" frameborder="0"
          class="tech-docs-iframe"></iframe>
      </div>
      <!-- 其他页面使用 router-view -->
      <router-view v-show="$route.path !== '/tech-docs'" />
    </el-main>
    <el-footer>
      <div class="footer-content">
        <p>©2025 UTS Data Technology Incorporated. All rights reserved. 沪ICP备2025153229号-1 | 版权所有 | 上海优特思数据科技有限公司
        </p>
      </div>
    </el-footer>
  </div>
</template>

<script>
import { getCurrentUser, checkUserLicenseStatus } from '@/api/user'
import { EventBus } from '@/utils/eventBus'

export default {
  name: 'App',
  data() {
    return {
      userInfo: null,
      userAvatar: '',
      // 使用响应式状态对象
      loginState: {
        isLoggedIn: !!localStorage.getItem('user_token'),
        userName: localStorage.getItem('user_name') || '用户'
      },
      licenseStatus: {
        hasLicense: false,
        isValid: false,
        loading: false,
        licenseInfo: null
      },
    }
  },
  computed: {
    showHeader() {
      return this.$route.meta.showHeader !== false
    },
    isLoggedIn() {
      return this.loginState.isLoggedIn
    },
    userName() {
      return this.loginState.userName
    },
    // 判断显示"开通会员"还是"授权管理"
    showLicenseButton() {
      if (!this.isLoggedIn) {
        return 'activate'; // 未登录显示开通会员
      }

      if (this.licenseStatus.loading) {
        return ''; // 加载中不显示
      }

      if (!this.licenseStatus.hasLicense || !this.licenseStatus.isValid) {
        return 'activate'; // 无授权或已过期显示开通会员
      }

      return 'manage'; // 有效授权显示授权管理
    },
    licenseButtonText() {
      switch (this.showLicenseButton) {
        case 'activate':
          return '开通会员';
        case 'manage':
          return '授权管理';
        default:
          return '';
      }

    }
  },
  methods: {

    // 处理菜单选择
    handleMenuSelect(index) {
      // 如果是技术文档，手动跳转到 /tech-docs 路由
      if (index === 'tech-docs') {
        this.$router.push('/tech-docs').catch(() => { });
      }
      // 其他菜单正常跳转（由 el-menu 的 router 属性处理）
    },

    handleUserCommand(command) {
      switch (command) {
        case 'profile':
          //this.$router.push('/user').catch(() => { });
          if (this.$route.path !== '/user') {
            this.$router.replace('/user')
          }
          break
        case 'logout':
          this.handleLogout()
          break
      }
    },

    handleLogout() {

      // 清除本地存储的用户信息
      localStorage.removeItem('user_token')
      localStorage.removeItem('user_id')
      localStorage.removeItem('user_name')

      // 更新响应式状态
      this.loginState.isLoggedIn = false;
      this.loginState.userName = '用户';

      // 重置授权状态
      this.licenseStatus = {
        hasLicense: false,
        isValid: false,
        loading: false,
        licenseInfo: null
      }

      // 触发退出登录事件
      EventBus.$emit('user-logout')

      // 强制更新确保界面刷新
      this.$forceUpdate();

      // 只有在当前不是首页时才跳转到首页
      if (this.$route.path !== '/') {
        this.$router.push('/')
      } else {
        // 如果已经在首页，只需要更新状态即可
        console.log('🔔 [App] 已在首页，无需跳转')
      }

    },
    // 检查授权状态（调用API）
    async checkLicenseStatus() {
      try {
        if (!this.isLoggedIn) {
          this.licenseStatus = {
            hasLicense: false,
            isValid: false,
            loading: false,
            licenseInfo: null
          };
          return;
        }

        this.licenseStatus.loading = true;

        // 调用API检查授权状态        
        const response = await checkUserLicenseStatus();

        if (response.code === 200) {
          const data = response.data;

          // 根据实际API响应结构调整
          const hasLicense = data.hasLicense ||
            (data.licenseInfo && data.licenseInfo.id) ||
            (data.status && data.status === 'active');

          const isValid = data.isValid ||
            (data.licenseInfo && !data.licenseInfo.is_expired) ||
            (data.expire_time && new Date(data.expire_time) > new Date());

          this.licenseStatus = {
            hasLicense: hasLicense,
            isValid: isValid,
            loading: false,
            licenseInfo: data.licenseInfo || data
          };
        }

      } catch (error) {
        console.error('检查授权状态失败:', error);
        this.licenseStatus.loading = false;
      }
    },

    // 处理授权按钮点击
    handleLicenseClick() {
      // 无论是"开通会员"还是"授权管理"，都跳转到购买页面
      this.$router.replace('/buy').catch(() => { });
    },

    // 处理登录按钮点击
    handleLoginClick() {
      // 检查当前页面，如果是购买相关页面，添加重定向参数
      const currentPath = this.$route.path;
      const isBuyPage = currentPath === '/buy' || currentPath.includes('/buy/');

      if (isBuyPage) {
        // 如果在购买页面，登录后需要回到当前页面
        this.$router.push({
          path: '/login',
          query: {
            redirect: currentPath,
            action: 'buy'
          }
        });
      } else {
        this.$router.push('/login');
      }
    },

    // 处理登录按钮点击
    handleRegisterClick() {
      // 跳转到登录页，并通过query参数告诉LoginPage显示注册表单
      this.$router.push({
        path: '/login',
        query: { view: 'register' } // 添加参数
      });
    },

    // 处理storage变化
    handleStorageChange(event) {
      if (event.key === 'user_token' || event.key === 'user_name') {
        console.log('🔄 [App] localStorage变化，重新加载状态');
        this.$forceUpdate();
        this.loadUserInfo();
      }
    },
    async loadUserInfo() {
      if (this.isLoggedIn) {
        try {

          const response = await getCurrentUser()
          if (response.code === 200) {
            this.userInfo = response.data

            // 更新响应式状态
            this.loginState.userName = response.data.nickname || '用户';

            // 更新本地存储的用户名
            if (response.data.nickname) {
              localStorage.setItem('user_name', response.data.userName)
            }

            // 检查授权状态
            await this.checkLicenseStatus();
          }


        } catch (error) {
          console.error('获取用户信息失败:', error)
          // 如果获取用户信息失败，可能是 token 过期，清除登录状态
          if (error.response && error.response.status === 401) {
            this.handleLogout()
          }
        }
      } else {
        // 未登录时重置授权状态
        this.licenseStatus = {
          hasLicense: false,
          isValid: false,
          loading: false,
          licenseInfo: null
        };
      }
    },
    // 处理登录/注册成功
    handleUserLogin(userData) {


      // 更新响应式状态 - 这会触发视图更新
      this.loginState.isLoggedIn = true;
      this.loginState.userName = userData.nickname || '用户';

      // 检查授权状态
      this.checkLicenseStatus();

      // 强制更新一次确保渲染
      this.$forceUpdate();
    },
  },
  watch: {
    // 监听登录状态变化
    isLoggedIn(newVal) {
      if (newVal) {
        // 登录后检查授权状态
        this.checkLicenseStatus();
      } else {
        // 退出登录重置状态
        this.licenseStatus = {
          hasLicense: false,
          isValid: false,
          loading: false,
          licenseInfo: null
        };
      }
    }
  },
  created() {
    // 监听登录事件
    EventBus.$on('user-login', this.handleUserLogin)
    // 监听退出登录事件
    EventBus.$on('user-logout', () => {
      this.loginState.isLoggedIn = false;
      this.loginState.userName = '用户';
      this.$forceUpdate();
    });
    // 监听注册成功事件（通过EventBus传递）
    EventBus.$on('register-success', this.handleUserLogin)
  },
  beforeDestroy() {
    // 移除事件监听
    EventBus.$off('user-login', this.handleUserLogin)
    EventBus.$off('user-logout')
    EventBus.$off('register-success', this.handleUserLogin)
    // 移除事件监听
    window.removeEventListener('storage', this.handleStorageChange);
  },

  mounted() {
    this.loadUserInfo()

    // 监听storage变化（当其他页面修改localStorage时）
    window.addEventListener('storage', this.handleStorageChange);

    // 监听路由变化，当从登录页返回时重新检查状态
    this.$router.afterEach((to, from) => {
      if (from.path === '/login' || from.path === '/register') {
        this.$nextTick(() => {
          this.checkLicenseStatus();
          this.$forceUpdate(); // 强制更新
        });
      }
    });
  },
}
</script>

<style scoped>
.app-header {
  background-color: #545c64;
  padding: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  min-width: 1024px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0 20px;
  height: 60px;
}

.footer-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}

.logo {
  display: flex;
  align-items: center;
  color: white;
  cursor: pointer;
  transition: opacity 0.3s ease;
  min-width: 300px;
}

.logo-image {
  width: 32px;
  height: 32px;
  margin-right: 10px;
}


.logo:hover {
  opacity: 0.8;
}

.logo-text {
  font-size: 20px;
  font-weight: bold;
}

.nav-menu {
  border-bottom: none;
  flex: 1;
  margin: 0 40px;
}

.user-actions {
  display: flex;
  align-items: center;
}

/* 授权按钮样式 */
.license-btn {
  transition: all 0.3s ease;
  min-width: 100px;
  margin-left: 10px;
  margin-right: 6px;
}

.license-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.license-btn i {
  margin-right: 5px;
}


/* 用户信息下拉菜单样式 */
.user-dropdown {
  cursor: pointer;
}

.user-info {
  display: flex;
  align-items: center;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.user-info:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.user-avatar {
  margin-right: 8px;
  background-color: orange;
  font-weight: bold;
}

.user-name {
  font-size: 14px;
  margin-right: 6px;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 下拉菜单样式 */
.user-dropdown-menu {
  margin-top: 5px;
  padding: 10px;
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 0px 16px;
  font-size: 14px;
  border-radius: 4px;
}

.dropdown-item i {
  margin-right: 8px;
  width: 16px;
  text-align: center;
}

.logout-item {
  color: #f56c6c;
}

.logout-item i {
  color: #f56c6c;
}

/* 技术文档容器样式 */
.tech-docs-container {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.tech-docs-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

/* 主内容区域 */
.app-main {
  height: calc(100vh - 120px);
  margin-top: 60px;
  background-color: #f5f7fa;
  min-width: 1200px;
  padding: 0 !important;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-content {
    padding: 0 15px;
  }

  .nav-menu {
    margin: 0 20px;
  }

  .user-name {
    max-width: 80px;
  }

  .logo-text {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .header-content {
    padding: 0 10px;
  }

  .nav-menu {
    margin: 0 10px;
  }

  .user-name {
    display: none;
  }

  .user-info {
    padding: 4px;
  }

  .logo-text {
    font-size: 16px;
  }
}

.quick-actions {
  text-align: center;
  display: inline-block;
}

.action-group {
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  flex-direction: column;
  align-items: stretch;
}

.action-group .el-button {
  margin: 0;
}
</style>